import { faArrowLeft, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

export const BackButton = (prop: any) => {
  const navigate = useNavigate();
  return (
    <>
      <button
        onClick={() => {
          navigate(-1);
        }}
        className="h-auto w-auto px-3 py-2 bg-white rounded-lg justify-center items-center mr-2"
      >
        <FontAwesomeIcon
          size="1x"
          icon={faChevronLeft}
          className=" cursor-pointer"
        />
      </button>
    </>
  );
};
